import React,{ Component } from 'react';
import {Row, Col } from 'antd';
import css from  './show.css';
export default class ColStudents extends Component {
    constructor(props) {
        super(props)
    }
    render(){
        const {param} = this.props;//传过来的值
        const {name} = this.props;//传过来的名称
        const {span} = this.props;//传过来的span,宽度比例
        {console.log('span',span!=undefined?span[0]:1)}
            return (
                <div>
                    <Row>
                        <Col span={span!=undefined?span[0]:9} className={css.col_left}>{name}:</Col>
                        <Col span={span!=undefined?span[1]:15} className={css.col_right}>{param}</Col>
                    </Row>
                </div>
            )
    }
}


// WEBPACK FOOTER //
// ./components/tjcx/queryStudents/gyQueryStudents/RowStudents.js